<template>
    <footer class="footer">
        <p class="pull-left">
            <router-link v-for="item in footerMenu" :key="item.title" tag="span" :to="item.link" exact>
                <a> {{ item.title }} </a>
            </router-link>
        </p>
        <p class="pull-right">Izdelava: <a href="tesispro.eu" target="_blank">©Tesis</a> | Moje živalce | 2006- {{ getYear }}</p>
    </footer>
</template>
<script>
export default {
    name:'app-footer',
    data() {
        // Package details
        return {
            footerMenu: [
                { icon: '', title: 'Domov', link: '/' },
                { icon: '', title: 'O nas', link: '/o-nas' },
                { icon: '', title: 'Kontakt', link: '/kontakt' },
                { icon: '', title: 'Blog', link: '/blog' },
                { icon: '', title: 'Galerija', link: '/galerija' },
            ],

        }
    },
    computed: {
        getYear() {
            let dt = new Date();
            return dt.getFullYear();
        }
    }

}

</script>




// WEBPACK FOOTER //
// src/components/layout/FooterBar.vue